import { render, staticRenderFns } from "./responsive-image.vue?vue&type=template&id=5a844f5f&scoped=true&"
import script from "./responsive-image.vue?vue&type=script&lang=js&"
export * from "./responsive-image.vue?vue&type=script&lang=js&"
import style0 from "./responsive-image.vue?vue&type=style&index=0&id=5a844f5f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a844f5f",
  null
  
)

export default component.exports